export enum BookingStatus {
  STARTED = 'STARTED',
  WITHDRAWN = 'WITHDRAWN',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
  CONFIRM_REQUESTED = 'CONFIRM_REQUESTED',
  PROCESSING_PAY_IN_METHOD_VERIFICATION = 'PROCESSING_PAY_IN_METHOD_VERIFICATION',
  BOOKED = 'BOOKED',
}
